export default __webpack_public_path__ + "assets/images/84af27c01851db71ae94ca9f18aa6e02.jpg";